import React from 'react';

const CheckCircleIcon = ({ className = '' }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
    stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
    className={className}>
    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
    <polyline points="22 4 12 14.01 9 11.01" />
  </svg>
);

const CartSummary = ({ selectedCount, subtotal }) => (
  <div className="flex items-center justify-between gap-2 px-3 sm:px-4 py-2.5 sm:py-3 bg-indigo-50 rounded-xl border border-indigo-100 mt-3">
    <div className="flex items-center gap-1.5 text-indigo-800 font-medium text-xs sm:text-sm min-w-0">
      <CheckCircleIcon className="w-3.5 h-3.5 sm:w-4 sm:h-4 flex-shrink-0" />
      <span className="truncate">
        {selectedCount > 0 ? `נבחרו ${selectedCount} שיעורים לתשלום` : 'לא נבחרו שיעורים לתשלום'}
      </span>
    </div>
    <span className="text-indigo-800 font-bold text-xs sm:text-sm whitespace-nowrap flex-shrink-0">
      סה"כ: ₪{subtotal}
    </span>
  </div>
);

export default CartSummary;